import { useContext, useState } from "react";
import { Context } from "../../../..";
import "../../../../Pages/LoginForm/LoginForm.css"
import ErrorComponent from "../../../UI/Error/ErrorComponent";
import UserService from "../../../../service/UserService";
import Succses from "../../../UI/Notification/Succses";
import { Spin } from "antd";
function Recovery({ props }) {


    const { store } = useContext(Context)
    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState("")
    const [password2, setPassword2] = useState("");
    const [statePassword,setStatePassword] = useState(false);
    const [statePassword2,setStatePassword2] = useState(false);

    const [loadButton, setLoadButton] = useState(false)
    console.log(props)
    async function handleButton() {
        try {
            if ((password === password2) && password && password2) {
                setLoadButton(true)
                const response = await UserService.change_password({ token: props.recovery_data, method: "change", password })
                if (response.data.status === 1) {
                    store.add_message("success1", Succses);

                    props.closeModal();
                    store.set_modal("login");

                }
                if (response.data.err) {
                    store.add_message(response.data.err, ErrorComponent)
                }
                setLoadButton(false)

            }
            else {
                store.add_message("Пароли не совпадают", ErrorComponent)
            }

        }
        catch (e) {
            console.log(e)

        }
    }

    return (
        <>
           


                <>

                    <div className="contentFormLogin">


                        <div className="login-box">
                            <span></span>
                            <span></span>
                            <span></span>



                            <form>





                                <div style={{ position: "relative" }}>
                                    <input className="password login_input" onChange={e => setPassword(e.target.value)}
                                        type={statePassword?"text":"password"} placeholder={"Введите новый пароль"} />
                                    <i style={{ top: "30px" }} class={`fa-solid ${statePassword ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePassword(prev => !prev)}></i>
                                </div>
                                <div style={{ position: "relative" }}><input className="password login_input" onChange={e => setPassword2(e.target.value)}
                                    type={statePassword2?"text":"password"} placeholder={"Подтвердите пароль"} />
                                    <i style={{ top: "30px" }} class={`fa-solid ${statePassword2 ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePassword2(prev => !prev)}></i>
                                </div>

                                {/*<ReCAPTCHA*/}
                                {/*    sitekey="6LeROBooAAAAAFgL6IfH4WBR9gv6xmfBwL-ZYv7Q"*/}
                                {/*    onChange={changer}*/}
                                {/*/>*/}
                                <div className="button_form1" onClick={async () => await handleButton()}>
                                    {loadButton ? <Spin /> : "Изменить пароль"}

                                </div>


                            </form>




                        </div>


                    </div>

                </>




            
        </>
    );

}
export default Recovery;